var React = require('react');

function PinkCheckmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 8.56069L5.89796 13.275L18.1429 1.48926","stroke":"#F51767","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

PinkCheckmark.defaultProps = {"width":"20","height":"15","viewBox":"0 0 20 15","fill":"none"};

module.exports = PinkCheckmark;

PinkCheckmark.default = PinkCheckmark;
